import { revalidateBindings } from './workbook'
import { BeatLoader } from 'react-spinners'
import ErrorMsg from './components/ErrorMsg'
import {
  INITIALIZE_OFFICE_SETTINGS_ERROR,
  INITIALIZE_OFFICE_SETTINGS_ERROR_CONTENT,
} from './constant'
import App from './App'
import { useQuery } from 'react-query'

const AppWrapper = () => {
  const { isLoading, error, isError } = useQuery({
    queryKey: ['REVALIDATE_BINDINGS'],
    queryFn: revalidateBindings,
    refetchOnWindowFocus: false,
    retry: 5,
  })

  if (isError) {
    return (
      <div
        className="w-full h-screen p-4 flex justify-center"
        data-testid="error-wrapper"
      >
        <div>
          <ErrorMsg
            title={INITIALIZE_OFFICE_SETTINGS_ERROR}
            content={INITIALIZE_OFFICE_SETTINGS_ERROR_CONTENT}
            error={
              error instanceof Error ? error : new Error(JSON.stringify(error))
            }
            reloadWindow={true}
          />
        </div>
      </div>
    )
  } else if (isLoading) {
    return (
      <div
        className="h-screen w-full flex justify-center items-center"
        data-testid="loading-wrapper"
      >
        <div className="flex flex-col justify-center items-center animate-bounce">
          <div>
            <BeatLoader size={20} color="#36d7b7" />
          </div>
          <div className="font-semibold">Verifying configs...</div>
        </div>
      </div>
    )
  } else {
    return <App />
  }
}

export default AppWrapper
